import {Base} from './Base'

export class Chassis extends Base {

  resourceName() {
    return 'chassis'
  }

  fields() {
    return [
      'name',
      'is_deleted',
    ]
  }

}